export const PLAN_OPTIONS = [
  { value: 'A', text: '永保20' },
  { value: 'B', text: '長安30' },
  { value: 'C', text: '安家10' },
];

export const PLAN_NAME_MAP = {
  A: '永保',
  B: '長安',
  C: '安家',
};

export const getPlanName = (plan) => PLAN_NAME_MAP[plan] || plan || '';



// WEBPACK FOOTER //
// ./src/models/HELPERS/plan.js